import { footerLinks } from "@/mocks/home";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-secondary-200 bg-secondary-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-play-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl tracking-wide text-foreground-950">
                51视频
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-700">
              本站是一个中立的入口汇总页，集中整理 51视频官网、最新地址、App下载与多端入口信息，
              帮助你在地址变化时快速找回可用访问方式。本站不提供内容存储，也不参与平台账号与付费流程。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="rounded-full bg-secondary-200 px-3 py-1 text-xs text-secondary-900">
                地址每日巡检
              </span>
              <span className="rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-900">
                信息仅作汇总
              </span>
            </div>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-heading text-base text-foreground-950">页面导航</h3>
            <div className="mt-4 grid grid-cols-2 gap-y-3 gap-x-4">
              {footerLinks.map((link) => (
                <a
                  key={link.id}
                  href={`#${link.id}`}
                  className="whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-600"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading text-base text-foreground-950">访问提示</h3>
            <ul className="mt-4 space-y-3 text-sm text-foreground-700">
              <li className="flex items-start gap-2">
                <i className="ri-bookmark-3-line mt-0.5 text-primary-500" aria-hidden="true"></i>
                <span>建议收藏本页，地址变化时随时回访。</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5 text-primary-500" aria-hidden="true"></i>
                <span>只从本页入口进入，警惕仿冒站点。</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-refresh-line mt-0.5 text-primary-500" aria-hidden="true"></i>
                <span>线路打不开时，优先切换到备用线路。</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-200 pt-6 text-xs text-foreground-600 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 51视频入口汇总页 · 本站为导航信息整理，非内容提供方</p>
          <p>内容仅供参考，请遵守当地法律法规与平台使用规则</p>
        </div>
      </div>
    </footer>
  );
}